import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: flex-start;
  

  padding: 8px 16px;

  form{
    width: 100%;
  }
`;

export const Content4 = styled.div`
  background: #fff;
  padding: 16px;
  border-radius: 4px;
`;

export const WrapperName = styled.div`
  font-size: 18px;
  display:flex;
  align-items:center;

  span{
    font-size: 18px;
    margin-left: 8px;
    text-decoration: line-through;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;

  width: calc(33.33% - 16px);
  margin: 8px;
  padding: 8px;
  border: 1px solid var(--color-border);
  border-radius: 4px;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
  margin-bottom: 8px;
  overflow: hidden;
  transition: transform 0.2s;

  &:hover{
    transform: translateY(-2px);
    box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);
  }

  @media (max-width: 767.98px) {
    width: 100%;
  }

`;

export const Content2 = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: flex-start;
  background: #fff;

  padding: 16px;
`;

export const WrapperRoles = styled.div`
  width:100%;
  display: flex;
  justify-content: start;

  min-height: 22px;

  span {
    color: #fff;
    padding: 3px 6px;
    background: var(--color-bg-gray);
    border-radius: 3px;
  }

`;

export const WrapperPaginate = styled.div`
  width:100%;
  display: flex;
  justify-content: center;
  margin: 8px 0;
`;

export const Date = styled.div`
  width:100%;
  display: flex;
  justify-content: center;
  padding: 2px;
  border-radius: 2%;
  color: var(--color-white);
  background-color: var(--color-bg-gray);
`;

export const Content3 = styled.div`
  &:hover {
    border-color: var(--color-bg-gray);
  }

  cursor: pointer;
`;

export const WrapperMenu = styled.div`
  position: absolute;
  top: 16px;
  right: 12px;
`;

export const Text = styled.h5`
  display: flex;
`;

export const WrapperRemove = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 4px;

  cursor: pointer;
  svg{
    color: var(--color-secondary);
  }

  &:hover{
    svg{
      color: var(--color-secondary-h);
    }
  }
`;